import React, { useEffect, useState } from "react";
import Space from "../ui/Space";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import Menu from "../ui/Menu";
import Checkbox from "../ui/Checkbox";
import { kbdEvent, setAll } from "../utils/Utils";
import Button from "../ui/Button";
import Float from "../ui/Float";

export default function PurchaseOrderUpdate(props) {

    const { callback = () => { }, route = "", options = [], filters = {} } = props;


    const getItem = (item) => ({
        text: (
            <Space size={10}>
                <Checkbox value={f[item.key]} />
                {item.label}
            </Space>
        ),
        sort: item.key,
        key: item.key,
        action: () => callback({ ...setAll(f, false), [item.key]: true }),
    });


    const [f, setF] = useState(
        options.reduce((acc, item) => {
            acc[item.key] = item.value;
            return acc;
        }, {})
    );


    const menu = [...options.map(getItem)];

    const [selected, setSelected] = useState(options[0]);

    useEffect(() => {

        const actions = [
            { key: KBD.ESCAPE, action: (e) => { callback(false) } },
            { key: KBD.ENTER, action: (e) => { handleCallback(selected) } },
            { key: KBD.PAGE_DOWN, action: (e) => { callback({ ...f }) } },
        ];

        const cleanup = listen(route, actions.concat(menu));
        return cleanup;
    }, [selected, f]);


    const handleCallback = (e) => {
        setSelected(e);
        setF({ ...f, [e]: !f[e] })
    }

    return (
        <div style={{ "width": "400px" }}>
            <div className="shim" /><div className="shim" />
            <Menu callback={(e) => handleCallback(e.sort)} bordered keyName="key" setSelected={setSelected} selected={selected} menu={menu} route={route} />
            <div className="shim" /><div className="shim" />
            <Float>
                <div></div>
                <Space>
                    <Button kbd={KBD.ESCAPE} onClick={() => callback(false)}>Cancel</Button>
                    <Button kbd={KBD.PAGE_DOWN} onClick={() => kbdEvent(KBD.PAGE_DOWN)} type="secondary">Apply</Button>
                </Space>
            </Float>
        </div>
    )
}